import * as React from 'react';
import * as mui from '@material-ui/core';
import {RoutedListItem} from './appshell/parts';
import { BrowserRouter, Route } from 'react-router-dom';


import * as AppConst from './AppConst';

import {AppAvatar} from './appshell-components/core/AppAvatar';

import {getAppVersion, getAppVersionMM} from './revision';


interface CLProps { type: 'SysApp'|'CustomerApp'|'CustomerAppTM'|'EpApp'|'UserApp'|'TestApp' ; }
interface CLState { component?: JSX.Element; }
class ComponentLoader extends React.Component<CLProps, CLState> {
  
  constructor(props: CLProps, ) {
    super(props);

    this.state = {};
  }



  componentDidMount() {

    if(this.props.type === 'SysApp') {
      import('./app/AppShellComponent_Sys').then((module)=>{
        this.setState({component: <module.default/> });
      });
    }

    if(this.props.type === 'CustomerApp') {
      import('./app/AppShellComponent_Customer').then((module)=>{
        this.setState({component: <module.default/> });
      });
    }
    
    if(this.props.type === 'EpApp') {
      import('./app/AppEp').then((module)=>{
        this.setState({component: <module.default/> });
      });
    }

    if(this.props.type === 'UserApp') {
      import('./app/AppShellComponent_User').then((module)=>{
        this.setState({component: <module.default/> });
      });
    }

    if(this.props.type === 'TestApp') {
      import('./TestApp').then((module)=>{
        this.setState({component: <module.default/> });
      });
    }

  }

  render() {
    return <React.Fragment>{ this.state.component ? this.state.component : null }</React.Fragment>;
  }
}



interface Param {
}

interface State {
    component: React.ComponentType;
}


class AppSelector extends React.Component<Param, State> {

  constructor(props: Param) {
    super(props);

    this.state = {
        component: ()=>(<div></div>)
    };

    const pnctx = new AppConst.PNCtx();

    AppAvatar.registerAvatarIcon('RODEM', `外部サービス「${pnctx.get('RODEM')}」への接続情報を保有しています`, require('.//images/rodem_icon.png'));
    AppAvatar.registerAvatarIcon('TM',`外部サービス「${pnctx.get('TRANSITMANAGER')}」への接続情報を保有しています`, require('.//images/tm_icon.png'));
    AppAvatar.registerAvatarIcon('TM_USER',`外部サービス「${pnctx.get('TRANSITMANAGER')}」の社員番号が割り当てられています`, require('.//images/tm_user_icon.png') );
    AppAvatar.registerAvatarIcon('OAUTH_SF', `外部サービス「${pnctx.get('SALESFORCE')}」への接続情報を保有しています`, require('.//images/sf_icon.png') );
    AppAvatar.registerAvatarIcon('GOOGLE', `外部サービス「${pnctx.get('Google')}」への接続情報を保有しています`, require('.//images/Google__G__Logo.svg') );

    AppAvatar.registerAvatarIcon('EXP_EXT_SRC__TM', `外部サービス「${pnctx.get('TRANSITMANAGER')}」上の情報を表示しています`, require('.//images/tm_icon.png') );

    
  }
  
  render() {

    const index = ()=> (
      <mui.Grid container>
        <mui.Grid item xs={12}>
          <mui.Typography align="center" variant="h5">{AppConst.APP_TITLE}</mui.Typography>
        </mui.Grid>

        <mui.Grid item xs={12}>

          <mui.List>
            <RoutedListItem location="/c/"><mui.ListItemText secondary={`${ AppConst.APP_NAME }の各種設定を行います`}>管理画面</mui.ListItemText></RoutedListItem>
            {/* <RoutedListItem location="/e/"><mui.ListItemText secondary={`${ AppConst.APP_EP_NAME }の画面です（専用アプリから接続する必要があります）`}>端末画面</mui.ListItemText></RoutedListItem> */}
            <RoutedListItem location="/u/"><mui.ListItemText secondary={`利用者個人に関する操作を行う画面です`}>利用者画面</mui.ListItemText></RoutedListItem>


            {/* <RoutedListItem location="/pub/"><mui.ListItemText secondary={`本サービス利用に必要となるリソースのダウンロードが可能です`}>ダウンロード</mui.ListItemText></RoutedListItem>
 */}

            <RoutedListItem location="/s/"><mui.ListItemText>システム管理者ログイン</mui.ListItemText></RoutedListItem>
            {/* <RoutedListItem location="/test/"><mui.ListItemText>Test</mui.ListItemText></RoutedListItem> */}
          </mui.List>

        </mui.Grid>
      </mui.Grid> 

      // <div>
        
      //   <RoutedButton location="/c/" label="customer"  />
      //   <RoutedButton location="/u/" label="user"  />
      //   <RoutedButton location="/e/" label="ep"  />
      // </div>
    );

    const appVersion = getAppVersion();
    const appVersionMM = getAppVersionMM();
    
    console.log('VERSION:', appVersionMM)

    return (
      <BrowserRouter basename={`/web/${appVersionMM}/`} >
        <React.Fragment>
          <Route exact path="/" component={index} />

          <Route path="/s/" render={ props => <ComponentLoader type="SysApp"/> }  />
          <Route path="/c/" render={ props => <ComponentLoader type="CustomerApp"/> } />
          <Route path="/c_tm/" render={ props => <ComponentLoader type="CustomerAppTM"/> } />
          <Route path="/e/" render={ props => <ComponentLoader type="EpApp"/> } />
          <Route path="/u/" render={ props => <ComponentLoader type="UserApp"/> } />
          <Route path="/test/" render={ props => <ComponentLoader type="TestApp"/> } />
          
          <div style={{position: 'fixed', bottom: '0px', right: '0px', color: 'lightgray', fontSize: 'xx-small'}}>
            {appVersion}
          </div>
        </React.Fragment>
      </BrowserRouter>
    );
  }

}

export default AppSelector;
